const spacings = {};

export default spacings;
